<template>
  <section
    v-if="isEditing || tabs.length"
    class="sticky top-[var(--sticky-top)] bg-background z-200"
  >
    <ScrollSpy v-if="tabs.length" :tabs="tabs" :disabled="isEditing" />
  </section>
</template>

<script lang="ts" setup>
import { notNullish } from '@vueuse/core'
import { toValidHtmlId } from '~/helpers'
import { getRuntimeOptions, getItemsforBundles } from '#blokkli/runtime-helpers'

const { rootBlocks, isEditing } = defineBlokkliFragment({
  name: 'anchor_navigation',
  label: 'Anchor Navigation',
  description:
    'Displays an anchor navigation with links to title paragraphs on this page.',
})

const tabs = computed(() =>
  getItemsforBundles(rootBlocks.value, ['title'])
    .map((item) => {
      const options = getRuntimeOptions(item)
      if (!options.showAnchor || !item.props) {
        return null
      }
      const label = item.props.anchorTitle || item.props.title
      if (!label) {
        return null
      }

      const id = toValidHtmlId(label)

      return {
        id,
        label,
      }
    })
    .filter(notNullish),
)
</script>
